import { render, staticRenderFns } from "./IconDividers.vue?vue&type=template&id=6b5c358f&"
import script from "./IconDividers.vue?vue&type=script&lang=js&"
export * from "./IconDividers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports